/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import RegularTemplate from '@/components/templates/RegularTemplate'
import { useAuth0 } from '@auth0/auth0-react'
import UserInfo from './components/UserInfo'
import { useAccount } from './useAccount'
import AppLicenses from './components/AppLicenses'
import VaultInfo from './components/VaultInfo'

const Account = ({
  auth0UserId,
  email,
  name,
  organization,
  userImageUrl,
  userLicenses,
  zetoniumUserId
}) => {
  const { getAccessTokenSilently: getAccessToken } = useAuth0()
  const {
    appLicenses,
    balance,
    loading,
    nickname,
    updateNickname
  } = useAccount({ getAccessToken, zetoniumUserId })
  const [screenLoader, setScreenLoader] = useState(false)

  return (
    <RegularTemplate
      title="User"
      loadingScreen={screenLoader}
      loadingContent={loading}
    >
      { !loading &&
        <>
          <div className="pages-padding-x mb-sm">
            <div className="container">
              <div className="columns">
                <div className="column is-6">
                  { zetoniumUserId && auth0UserId &&
                    <UserInfo
                      altImage={name}
                      auth0UserId={auth0UserId}
                      balances={balance}
                      className="mb-md"
                      email={email}
                      getAccessToken={getAccessToken}
                      name={name}
                      nickname={nickname?.nickname}
                      organizationName={organization?.display_name}
                      silverZetons={balance}
                      updateNickname={updateNickname}
                      urlImage={userImageUrl}
                      zetoniumUserId={zetoniumUserId}
                    />
                  }
                </div>
                <div className="column is-6">
                  <VaultInfo />
                </div>
              </div>
            </div>
            <div className="container">
              <AppLicenses
                appLicenses={appLicenses}
                userLicenses={userLicenses}
                setScreenLoader={setScreenLoader}
              />
            </div>
          </div>
        </>
      }

    </RegularTemplate>
  )
}

export default Account
